<script setup lang="ts">
import AppButton from "@/components/atoms/button/AppButton.vue";
import TextAreaGroup from "@/components/molecules/form/TextAreaGroup.vue";
import { required } from "@vee-validate/rules";
import { ref } from "vue";

const props = defineProps({
  isShown: {
    type: Boolean,
    default: false
  },
  officeName: {
    type: String,
    required: true
  }
});

const reason = ref("");
const emit = defineEmits(["submit", "cancel"]);

function clearForm() {
  reason.value = "";
}

function onCancel() {
  emit("cancel");
  clearForm();
}

function onSubmit() {
  emit("submit", { reason: reason.value });
  clearForm();
}
</script>
<template>
  <CustomValidationObserver v-slot="{ handleSubmit }" ref="form">
    <BModal
      :modelValue="isShown"
      title="事業所ミュートの登録"
      no-close-on-backdrop
      no-close-on-esc
      centered
      @close="onCancel"
      @hide="onCancel"
    >
      <div class="text-size-14 font-weight-bold" data-testid="description">
        <div>{{ officeName }}をミュートリストに登録します</div>
      </div>
      <div class="mt-1 text-size-12">
        ミュートすると事業所のお仕事が一覧に表示されなくなります
      </div>
      <ValidationProvider
        v-slot="validationState"
        :rules="{ required, max: 2000 }"
        name="ミュートする理由"
        tag="div"
        class="mt-2"
        vid="reason"
      >
        <TextAreaGroup
          v-model="reason"
          appLabelText="必須"
          label="ミュートする理由"
          :validationState="validationState"
          class="mt-1"
        />
        <div class="my-2 text-size-12">
          今後のサービス運営のために率直なご意見をお聞かせください<br />
          ミュートする理由については事業所様には伝わりません
        </div>
      </ValidationProvider>
      <template #modal-footer>
        <AppButton
          class="text-weight-500"
          variant="mild"
          @click="onCancel"
          data-testid="cancel-button"
        >
          キャンセル
        </AppButton>
        <AppButton
          class="ml-2 text-weight-500"
          variant="primary"
          @click="handleSubmit(onSubmit)"
          data-testid="submit-button"
        >
          ミュートする
        </AppButton>
      </template>
    </BModal>
  </CustomValidationObserver>
</template>
